@for (templateText of templateTexts; track templateText) {
  <button
    class="btn"
    type="button"
    (click)="templateClick(templateText)"
    >
    {{ templateText.label | translate }}
  </button>
}
